import clone from 'clone'
import { actions } from './actions'
import { mutations } from './mutations'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  uploadTreatyPremComm: {
    init: 0,
    initErr: [],
    menu: {}
  },
  uploadTreatyClmPaymRes: {
    init: 0,
    initErr: [],
    menu: {}
  },
  genQuartStmt: {
    init: 0,
    initErr: [],
    menu: {}
  },
  batchRelMthlyTtyStmt: {
    init: 0,
    initErr: [],
    menu: {}
  },
  batchRelQrtlyTtyStmt: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

export default {
  // deep clone here, we need the initialState for resetting of state in ClaimNew
  state: clone(initialState),
  mutations,
  actions
}
